import { BackgroundColours } from '@honeycomb/data';
export function getBackgroundColor(color, palette) {
    switch (color.name) {
        case BackgroundColours.Primary:
            return palette.primary.base;
        case BackgroundColours.Secondary:
            return palette.secondary.base;
        case BackgroundColours.Accent:
            return palette.accent.base;
        case BackgroundColours.Offset:
            return palette.background.offset;
        case BackgroundColours.White:
            return palette.common.white;
        case BackgroundColours.Black:
            return palette.common.black;
        default:
            return '';
    }
}
